import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SimpleBar from "simplebar-react";
//import logo
import logoSm from "../assets/images/logo-sm.png";
// import logoDark from "../assets/images/logo-dark.png";
// import logoLight from "../assets/images/logo-light.png";
import logoDark from "../assets/images/DBinsight-logodark.svg";
import logoLight from "../assets/images/DBinishgt-logowhite.svg";
import { useLocation } from "react-router-dom";

//Import Components

import { Container, Button } from "reactstrap";
import BotLayout from "./BotLayout";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { change_inner_side_bar_visibility } from "../slices/SideBarCust/reducer";

const SidebarCust = ({ layoutType }) => {

  const location = useLocation();
  const { inner_side_value } = useSelector((state)=>state.SidebarCust)
  const {pathname } = location;




     
 

  useEffect(() => {
    var verticalOverlay = document.getElementsByClassName("vertical-overlay");
    if (verticalOverlay) {
      verticalOverlay[0].addEventListener("click", function () {
        document.body.classList.remove("vertical-sidebar-enable");
      });
    }
  });
  

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover-active');
    } else if (document.documentElement.getAttribute('data-sidebar-size') === 'sm-hover-active') {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    } else {
      document.documentElement.setAttribute('data-sidebar-size', 'sm-hover');
    }
  };

  
const dispatch=useDispatch();

const open_inner_side_bar = ()=>{
    dispatch(change_inner_side_bar_visibility('close'))
}
  return (
    <React.Fragment>
      <div className={` ${inner_side_value} custom_sidebar_inner border-end fixed-width`}>
        {/* <div className="navbar-brand-box">
      <Link to="/" className="logo logo-dark">
        <span className="logo-sm">0
          <img src={logoSm} alt="" height="22" />
        </span>
        <span className="logo-lg">
          <img src={logoDark} alt="" height="30" />
        </span>
      </Link>

      <Link to="/" className="logo logo-light">
        <span className="logo-sm">
          <img src={logoSm} alt="" height="22" />
        </span>
        <span className="logo-lg">
          <img src={logoLight} alt="" height="30" />
        </span>
      </Link>
      <button
        onClick={addEventListenerOnSmHoverMenu}
        type="button"
        className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
        id="vertical-hover"
      >
        <i className="ri-record-circle-line"></i>
      </button>
    </div> */}
        <React.Fragment>
          <SimpleBar id="scrollbar" className="h-100 testing">
          <div className='mobile_logo'>
             <img className="logoDark" src={logoDark} alt="" height="30" />
             <img className="logoLight" src={logoLight} alt="" height="30" />
          </div>  
          <div className="close_mobile">
             <Button onClick={open_inner_side_bar} color="secondary" className="btn-icon" outline> <i className="ri-close-circle-line" /> </Button>
          </div>
            <Container fluid>
              <div id="two-column-menu"></div>
              <ul className="navbar-nav" id="navbar-nav">
                <BotLayout layoutType={'semibox'} />
              </ul>
            </Container>
          </SimpleBar>
          <div className="sidebar-background"></div>
        </React.Fragment>
      </div><div className="vertical-overlay"></div>
    </React.Fragment>
  );
};

export default SidebarCust;
